<template>
    <div>
        <v-row>
            <v-col>
                <h3 class="panel-max-size-header">{{ $t('components.panelCountEstimator.maxPanelSize') }}</h3>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="6">
                <v-text-field
                    :label="$t('placeholders.maxPanelLength')"
                    :model-value="width"
                    @update:model-value="val => emit('update:width', val)"
                    type="number"
                ></v-text-field>
            </v-col>
            <v-col cols="6">
                <v-text-field
                    :label="$t('placeholders.maxPanelWidth')"
                    :model-value="length"
                    @update:model-value="val => emit('update:length', val)"
                    type="number"
                ></v-text-field>
            </v-col>
        </v-row>
    </div>
</template>

<script setup>


defineProps({
    width: {
        type: Number,
        required: true
    },
    length: {
        type: Number,
        required: true
    }
});
const emit = defineEmits(['update:width', 'update:length']);
</script>

<style scoped>
@import '@/assets/styles/components/panelCountEstimator/PanelMaxSizeInputs.css';
</style>